/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import MoreVertIcon from '@material-ui/icons/MoreVert';

// Constants
import CONSTANTS from 'constants/attendance';

interface Props {
  getUnit: any;
}

const SetTimeUnit: React.FC<Props> = ({ getUnit }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (data: any) => {
    getUnit(data);
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip title='Selecionar unidade' placement='left'>
        <IconButton onClick={handleClick}>
          <MoreVertIcon />
        </IconButton>
      </Tooltip>
      <Menu
        id='long-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}>
        {CONSTANTS.TIME_UNIT.map((option) => (
          <MenuItem key={option.KEY} onClick={() => handleClose(option.VALUE)}>
            {option.LABEL}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default SetTimeUnit;
export { SetTimeUnit };
